export const AVATAR_DESCRIPTIONS = 'avatar description';
export const AVATAR_CONFIG_DETAILS = 'avatar config details';
export const AVATAR_PROFILE = 'avatar profile';
export const USER_IDEAS = 'user ideas';
export const PUBLIC_AVATARS = 'public avatars';
export const MATCHED_AVATARS = 'matchedAvatars';
